<template>
  <div class="px-3">
    <div>
      <fdw-nfl-matchup accent-color="#E42C2C" client="114"></fdw-nfl-matchup>
    </div>
    <div style="margin-top: 15px">
      <fdw-odds-movement
        accent-color="#E42C2C"
        client="114"
        league-id="101"
      ></fdw-odds-movement>
    </div>
    <div style="margin-top: 15px">
      <fdw-injury
        accent-color="#E42C2C"
        client="114"
        league-id="101"
      ></fdw-injury>
    </div>
  </div>
</template>

<script>
export default {
  name: "NflMatchup",
};
</script>
